import React from 'react';
import PropTypes from 'prop-types';
import {
  IncomeAndNetWorthAccordionItem,
  MedicalCareAccordionItem,
  DependentChildrenAccordionItem,
  MarriageHistoryAccordionItem,
  MilitaryHistoryAccordionItem,
} from './SupportingDocAccordionItems';

/** Always shows. */
export const RequiredDocumentsAccordion = () => (
  <va-accordion>
    <va-accordion-item level={5} bordered header="Veteran’s death certificate">
      <p>
        You’ll need to submit a copy of the Veteran’s death certificate. It must
        clearly show the primary cause of death and any contributing factors or
        conditions.
      </p>
      <p>
        <strong>Note:</strong> If the Veteran’s death certificate lists the
        cause of death as "Pending," have the medical examiner submit evidence
        that shows the cause of death.
      </p>
    </va-accordion-item>

    <va-accordion-item
      level={5}
      bordered
      header="Veteran’s DD214 or separation documents"
    >
      <p>
        You’ll need to submit a copy of the Veteran’s DD214 or equivalent for
        all periods of military service. It must show when they served, the type
        of service, and the character of their discharge.
      </p>
      <p>
        You can request a copy of the Veteran’s DD214 and other military service
        records from the National Archives.
      </p>
      <va-link
        href="https://www.va.gov/records/get-military-service-records#how-to-request-your-records-fr"
        external
        text="Learn more about how to request military service records from the National Archives"
      />
    </va-accordion-item>
  </va-accordion>
);

export const OtherDocumentsAccordion = ({ formData }) => {
  const items = [
    ['income', IncomeAndNetWorthAccordionItem({ formData })],
    ['medical', MedicalCareAccordionItem({ formData })],
    ['dependents', DependentChildrenAccordionItem({ formData })],
    ['marriage', MarriageHistoryAccordionItem({ formData })],
    ['military', MilitaryHistoryAccordionItem({ formData })],
  ].filter(([, el]) => el);

  if (items.length === 0) return null;

  return (
    <>
      <h4 className="vads-u-color--gray-dark">Other documents you may need</h4>
      <va-accordion>
        {items.map(([key, el]) => (
          <React.Fragment key={key}>{el}</React.Fragment>
        ))}
      </va-accordion>
    </>
  );
};

OtherDocumentsAccordion.propTypes = {
  formData: PropTypes.object,
};
